// import { isURL } from '@/utils/validate'

import {formt} from "./filters";

//获取地址栏参数
export function getUrlParams(str) {
    if (str) {
        const _arr = str.split('?');
        const arr = _arr[1].split('&');
        return arr.reduce(function (json, val) {
            const _tmp = val.split('=');
            json[_tmp[0]] = _tmp[1];
            return json
        }, {})
    }
    return {}
}

//判断是否为今天
export function isToday(str) {
    const d = new Date(str.replace(/-/g, "/"));
    const todaysDate = new Date();
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
        return true;
    } else {
        return false;
    }
}

export function timeFix() {
    const time = new Date()
    const hour = time.getHours()
    return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome() {
    const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
    let index = Math.floor((Math.random() * arr.length))
    return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
    let event = document.createEvent('HTMLEvents')
    event.initEvent('resize', true, true)
    event.eventType = 'message';
    window.dispatchEvent(event)
}

/**
 * 过滤对象中为空的属性
 * @param obj
 * @returns {*}
 */
export function filterObj(obj) {
    if (!(typeof obj == 'object')) {
        return;
    }

    for (var key in obj) {
        if (obj.hasOwnProperty(key)
            && obj[key] !== 0 && (obj[key] == null || obj[key] == undefined || obj[key] === '')) {
            delete obj[key];
        }
    }
    return obj;
}

export function dk_formatDate(value, fmt, status) {
    if (value) {
        const _date = value.replace ? new Date(value.replace(/-/g, "/")) : new Date(value);
        if (_date && _date instanceof Date && !isNaN(_date.getTime())) {

            const Y = _date.getFullYear();
            const M = _date.getMonth() + 1;
            const D = _date.getDate();
            const H = _date.getHours();
            const m = _date.getMinutes();
            const s = _date.getSeconds();
            if (fmt === '年') {
                if (status) {
                    return formt(Y) + '年' + formt(M) + '月' + formt(D) + '日' + ' ' + [H, m, s].map(formt).join(':')
                }
                return formt(Y) + '年' + formt(M) + '月' + formt(D) + '日'
            } else {
                if (status) {
                    return [Y, M, D].map(formt).join(fmt) + ' ' + [H, m, s].map(formt).join(':')
                }
                return [Y, M, D].map(formt).join(fmt);
            }

        }
        return ''
    }
    return ''
}

/**
 * 时间格式化
 * @param value
 * @param fmt
 * @returns {*}
 */
export function formatDate(value, fmt) {
    var regPos = /^\d+(\.\d+)?$/;
    if (regPos.test(value)) {
        //如果是数字
        let getDate = new Date(value);
        let o = {
            'M+': getDate.getMonth() + 1,
            'd+': getDate.getDate(),
            'h+': getDate.getHours(),
            'm+': getDate.getMinutes(),
            's+': getDate.getSeconds(),
            'q+': Math.floor((getDate.getMonth() + 3) / 3),
            'S': getDate.getMilliseconds()
        };
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (getDate.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in o) {
            if (new RegExp('(' + k + ')').test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
            }
        }
        return fmt;
    } else {
        //TODO
        value = value.trim();
        return value.substr(0, fmt.length);
    }
}

// 生成首页路由
// export function generateIndexRouter(data) {
// let indexRouter = [{
//           path: '/',
//           name: 'dashboard',
//           //component: () => import('@/components/layouts/BasicLayout'),
//           component: resolve => require(['@/components/layouts/TabLayout'], resolve),
//           meta: { title: '首页' },
//           redirect: '/dashboard/analysis',
//           children: [
//             ...generateChildRouters(data)
//           ]
//         },{
//           "path": "*", "redirect": "/404", "hidden": true
//         }]
//   return indexRouter;
// }

// 生成嵌套路由（子路由）

// function  generateChildRouters (data) {
//   const routers = [];
//   for (var item of data) {
//     let component = "";
//     if(item.component.indexOf("layouts")>=0){
//        component = "components/"+item.component;
//     }else{
//        component = "views/"+item.component;
//     }
//
//     // eslint-disable-next-line
//     let URL = (item.meta.url|| '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
//     if (isURL(URL)) {
//       item.meta.url = URL;
//     }
//
//     let menu =  {
//       path: item.path,
//       name: item.name,
//       redirect:item.redirect,
//       component: resolve => require(['@/' + component+'.vue'], resolve),
//       hidden:item.hidden,
//       //component:()=> import(`@/views/${item.component}.vue`),
//       meta: {
//         title:item.meta.title ,
//         icon: item.meta.icon,
//         url:item.meta.url ,
//         permissionList:item.meta.permissionList,
//         keepAlive:item.meta.keepAlive
//       }
//     }
//     if(item.alwaysShow){
//       menu.alwaysShow = true;
//       menu.redirect = menu.path;
//     }
//     if (item.children && item.children.length > 0) {
//       menu.children = [...generateChildRouters( item.children)];
//     }
//     //--update-begin----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
//     //判断是否生成路由
//     if(item.route && item.route === '0'){
//       //console.log(' 不生成路由 item.route：  '+item.route);
//       //console.log(' 不生成路由 item.path：  '+item.path);
//     }else{
//       routers.push(menu);
//     }
//     //--update-end----author:scott---date:20190320------for:根据后台菜单配置，判断是否路由菜单字段，动态选择是否生成路由（为了支持参数URL菜单）------
//   }
//   return routers
// }

/**
 * 深度克隆对象、数组
 * @param obj 被克隆的对象
 * @return 克隆后的对象
 */
export function cloneObject(obj) {
    return JSON.parse(JSON.stringify(obj))
}

/**
 * 随机生成数字
 *
 * 示例：生成长度为 12 的随机数：randomNumber(12)
 * 示例：生成 3~23 之间的随机数：randomNumber(3, 23)
 *
 * @param1 最小值 | 长度
 * @param2 最大值
 * @return int 生成后的数字
 */
export function randomNumber() {
    // 生成 最小值 到 最大值 区间的随机数
    const random = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1) + min)
    }
    if (arguments.length === 1) {
        let [length] = arguments
        // 生成指定长度的随机数字，首位一定不是 0
        let nums = [...Array(length).keys()].map((i) => (i > 0 ? random(0, 9) : random(1, 9)))
        return parseInt(nums.join(''))
    } else if (arguments.length >= 2) {
        let [min, max] = arguments
        return random(min, max)
    } else {
        return Number.NaN
    }
}

/**
 * 随机生成字符串
 * @param length 字符串的长度
 * @param chats 可选字符串区间（只会生成传入的字符串中的字符）
 * @return string 生成的字符串
 */
export function randomString(length, chats) {
    if (!length) length = 1
    if (!chats) chats = '0123456789qwertyuioplkjhgfdsazxcvbnm'
    let str = ''
    for (let i = 0; i < length; i++) {
        let num = randomNumber(0, chats.length - 1)
        str += chats[num]
    }
    return str
}

/**
 * 随机生成uuid
 * @return string 生成的uuid
 */
export function randomUUID() {
    let chats = '0123456789abcdef'
    return randomString(32, chats)
}

/**
 * 下划线转驼峰
 * @param string
 * @returns {*}
 */
export function underLine2CamelCase(string) {
    return string.replace(/_([a-z])/g, function (all, letter) {
        return letter.toUpperCase();
    });
}

/**
 * 判断是否显示办理按钮
 * @param bpmStatus
 * @returns {*}
 */
export function showDealBtn(bpmStatus) {
    if (bpmStatus != "1" && bpmStatus != "3" && bpmStatus != "4") {
        return true;
    }
    return false;
}

/**
 * 增强CSS，可以在页面上输出全局css
 * @param css 要增强的css
 * @param id style标签的id，可以用来清除旧样式
 */
export function cssExpand(css, id) {
    let style = document.createElement('style')
    style.type = "text/css"
    style.innerHTML = `@charset "UTF-8"; ${css}`
    // 清除旧样式
    if (id) {
        let $style = document.getElementById(id)
        if ($style != null) $style.outerHTML = ''
        style.id = id
    }
    // 应用新样式
    document.head.appendChild(style)
}

export function getAppId() {
    //正式
    // const captcha = '2019232819';
    //测试
    const captcha = '2078399419';

    return captcha
}
